import React, { useMemo } from "react";
import styled from "styled-components";
import LoginBoxV2 from "_+_Portal/components/Auth/LoginBoxV2/LoginBoxV2";
import Keyboard from "_+_Portal/components/Genericos/Keyboard/Keyboard";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background: var(--color-primary-gradient-y);
`;

const LeftPanel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
`;

const RightPanel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`;

const DesktopLoginLayout = ({
  form,
  error,
  onChange,
  onSubmit,
  loginFormValid,
  loading,
}) => {
  const nroDocumentoValue = useMemo(() => {
    if (!Array.isArray(form)) return "";
    const field = form.find((f) => f?.name === "nro_documento");
    return field?.value || "";
  }, [form]);

  const handleKeyboardChange = (nextValue) => {
    // Enviamos como si fuese un change del input nro_documento
    onChange({ target: { name: "nro_documento", value: nextValue } });
  };

  const handleEnter = () => {
    if (loginFormValid && !loading) {
      onSubmit(form);
    }
  };

  return (
    <Container>
      <LeftPanel>
        <LoginBoxV2
          form={form}
          onChange={onChange}
          onSubmit={() => onSubmit(form)}
          loginFormValid={loginFormValid}
          loading={loading}
          error={error}
        />
      </LeftPanel>
      <RightPanel>
        <Keyboard
          value={nroDocumentoValue}
          onChange={handleKeyboardChange}
          onEnter={handleEnter}
          maxLength={8}
        />
      </RightPanel>
    </Container>
  );
};

export default DesktopLoginLayout;
